import React from 'react'
import linkStyles from './Parties.module.css'
import { ThemeProvider, Typography, CssBaseline} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2';
import {theme} from '../../theme.js'
import { TopBar } from '../../components/TopBar/TopBar'
import {Footer} from '../../components/Footer/Footer'
import tiling from '../../images/blue-tile.png'
import banner from '../../images/parties_banner.jpg'
import party1 from '../../images/party1.jpg'
import party2 from '../../images/party3.jpg'
import vr1 from '../../images/vr1.jpg'
import Google from '../../images/Google-Reviews.png'
import Yelp from '../../images/yelp-5-stars.png'
import Stars from '../../images/5-stars.png'
import { Box } from '@mui/system';
export const Parties = () => {
    let glink = "https://www.google.com/search?q=diablo+escapes+google+reviews&client=ubuntu&hs=L60&channel=fs&sxsrf=ALiCzsbArJ8pzNj-s40FQOj0HfXIfwy87w%3A1666139732988&ei=VEZPY5TNO-7aptQPsZqzwAY&ved=0ahUKEwiUx7iXhuv6AhVurYkEHTHNDGgQ4dUDCA4&uact=5&oq=diablo+escapes+google+reviews&gs_lcp=Cgxnd3Mtd2l6LXNlcnAQAzIFCCEQoAE6BwgjELADECc6DQgAEEcQ1gQQsAMQyQM6CggAEEcQ1gQQsAM6CAgAEJIDELADOgQIIxAnOgsILhCABBDHARCvAToFCAAQgAQ6BQgAEIYDOgUIIRCrAjoHCCEQoAEQCjoICCEQFhAeEB1KBAhBGABKBAhGGABQ2QFY6w1glg5oAXABeACAAccBiAGZEJIBBDAuMTSYAQCgAQHIAQrAAQE&sclient=gws-wiz-serp#lrd=0x808561edc967c1a1:0x123f58a04af6faff,1,,,"
  let ylink = "https://www.yelp.com/biz/diablo-escapes-walnut-creek"
  
  return (
    
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <Grid container style={{backgroundImage:`url(${tiling})`, backgroundAttachment:"fixed", alignItems:"center"}} className={linkStyles.parties} alignItems={"stretch"}>
        <Grid item xs={12}>
          <TopBar/>
        </Grid>
        <Grid item xs={12}>
            <img src={banner} width="100%" alt="Banner"/>
        </Grid>
        <Grid item xs={12} textAlign="center" pb={5} display={{xs:"none", md:"block"}}>
          <Typography color="white" variant="h4" fontFamily={"Copperplate"} >
          Birthday Parties · Bar/bat mitzvah · Quinceañera · Graduation
          </Typography>
        </Grid>
        <Grid item xs={12} md = {6} paddingLeft = {{xs: 5, sm:10, md: 20}} paddingRight={{xs: 5, sm:10, md:0}} pb={5}>
                <Box sx={{borderBottom:1, borderColor:"white", marginBottom:1}}>
                <Typography color="white" variant="h4" fontFamily={"Sans-Serif"} textAlign={"center"}>
                  Birthdays
                </Typography>
                </Box>
                <Typography color="white" variant="h5" fontFamily={"Sans-Serif"}>
                From your 10th to your 80th... 
                we're excited to have your special event here with us at Diablo 
                Escapes! There's nothing more memorable than orbiting Earth or 
                slaying a dragon on your birthday! Spend your special day doing 
                something fun, adventurous and unique!
                </Typography>
        </Grid>
        <Grid item xs={6} md = {3} paddingLeft={{xs:5, md:10}} paddingRight={{xs:5, md:10}} pb={5}>
                <img src={party1} width="100%" alt="Bday party"/>
        </Grid>
        <Grid item xs={6} md = {3} paddingRight={{xs: 5, md:20}} paddingLeft={{xs: 5, md:0}} pb={5}>
            <img src={party2} width ="100%" alt="Bday party"/>
        </Grid>
        <Grid item xs={12} md = {6} paddingLeft = {{xs: 5, sm:10, md: 20}} paddingRight={{xs: 5, sm:10, md:0}} pb={5}>
        <Typography color="white" variant="h4" textAlign={"center"} fontFamily={"Sans-Serif"}>
        <Box sx={{borderBottom:1, borderColor:"white", marginBottom:1}}>
                <Typography color="white" variant="h4" fontFamily={"Sans-Serif"} textAlign={"center"}>
                  Other Special Events
                </Typography>
                </Box>
                Whatever you have in mind... we're in! <br/><br/>
                Call us to learn more about what's possible! <br/><br/>
                925-393-7171
                </Typography>
        </Grid>
        <Grid item xs={12} md = {6} paddingRight={{xs:5, md:20}} paddingLeft={{xs:5, md:10}}>
            <img src={vr1} width="100%" alt="VR headsets"/>
        </Grid>
        <Grid item xs={12} md={6} paddingLeft={{xs:5, md:20}} paddingRight={{xs:5, md:0}}>
                <Typography color="white" variant="h6" fontFamily={"Sans-Serif"}>
                <ul>
                <li>Private parties get to use the entire space, making this a uniquely exclusive experience!</li><br/>  

                <li>Personalize the rooms with decorations</li><br/> 

                <li>Bring your own food, drinks and cake</li><br/> 

                <li>Non-players are also welcome to enjoy the space while others seek adventure in our amazing VR rooms</li><br/> 

                <li>Party packages start at $492 for 8 players</li><br/> 

                <li>We have two VR rooms which can handle up to 6 players each.</li><br/> 

                <li>Play head-to-head and compete for best time</li><br/> 

                <li>Specialized parties for up to 40 players</li>
                </ul>
                </Typography>
        </Grid>
        <Grid item xs ={12} md = {6} pb={5} paddingRight={{xs:5, md: 20}} paddingLeft={{xs:5, md: 10}}>
            <Box textAlign={"center"}>
            <img src = {Yelp} alt = "Yelp Reviews" style={{width:"50%", objectFit:"contain"}}/>
            </Box>
            <Box position="relative" pt={5}>
            <img src = {Stars} alt = "stars" style={{maxWidth:"25%"}}/>
              <Typography color="white" fontFamily={"Sans-Serif"} variant="h6">
              "This place is great! So much fun. I booked them to celebrate my 
              15 year olds birthday celebration. Super easy to book on the website.
               Upon arrival, I was impressed just walking in the door. Their facility
                is SUPER clean and cutely decorated. ..." <br></br><br></br>
                -- Genny M., Martinez <br></br>
              <a href={ylink}>Read more reviews...</a>
              </Typography>
            </Box>
        </Grid>
        <Grid item xs={12} md={6} paddingLeft={20} textAlign={"center"} display={{xs:"none", md:"flex"}}>
                <Typography color="white" variant="h3" textAlign={"center"}>
                Call 925-393-7171 <br/>for more info.
                </Typography>
        </Grid>
        <Grid item xs ={12} md = {6} pb={5} paddingRight={{xs:5, md: 20}} paddingLeft={{xs:5, md: 10}} >
            <Box textAlign={"center"} >
            <img src = {Google} alt = "Google Reviews" style={{width:"40%", objectFit:"contain"}}/>
            </Box>
            <Box position="relative" pt={5}>
            <img src = {Stars} alt = "stars" style={{maxWidth:"25%"}}/>
              <Typography color="white" fontFamily={"Sans-Serif"} variant="h6" >
              "My son's 13th birthday at Diablo Escapes was off the charts fantastic!" <br></br><br></br>
              -Lori, Walnut Creek <br></br>
              <a href={glink}>Read more reviews...</a>
              </Typography>
            </Box>
        </Grid>
        <Grid item xs={12} md={6} paddingX={10} display={{xs:"block", md:"none"}}>
                <Typography color="white" variant="h3" textAlign={"center"}>
                Call 925-393-7171 <br/>for more info.
                </Typography>
        </Grid>
      <Footer/>
      </Grid>
    </ThemeProvider>
    )
}
